<div style="height:100vh;display: flex;flex-direction: column;">
    <div style="flex: 1;"></div>
    <h2 style="text-align: center;flex: 1;">{{message}}</h2>
    <div style="flex: 1;"></div>
</div>
